export default __webpack_public_path__ + "static/media/FLOW-login-background.1eae1784.jpg";